/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BankruptciesFilterRequest { 
    publicationDateFrom?: number;
    publicationDateTo?: number;
    createdAtFrom?: number;
    createdAtTo?: number;
    companyId?: string;
    phases?: Array<BankruptciesFilterRequest.PhasesEnum>;
}
export namespace BankruptciesFilterRequest {
    export type PhasesEnum = 'PRE_BANKRUPTCY' | 'BANKRUPTCY_PROCEEDINGS_OPEN' | 'CREDITORS_ASSEMBLY' | 'FILING_IN_BANKRUPTCY_FILE' | 'BANKRUPTCY_PROCEEDINGS_OPEN_CLOSE' | 'BANKRUPTCY_PROCEEDINGS_OPEN_CREDITORS_ASSEMBLY' | 'BANKRUPTCY_PROCEEDINGS_CLOSE' | 'SUSPEND_PRE_BANKRUPTCY' | 'BANKRUPTCY_TRUSTEE_CHANGE' | 'PROPERTY_SALE' | 'PROPERTY_ASSESSMENT' | 'PROCUREMENT_SERVICES_GOODS' | 'OTHER';
    export const PhasesEnum = {
        PREBANKRUPTCY: 'PRE_BANKRUPTCY' as PhasesEnum,
        BANKRUPTCYPROCEEDINGSOPEN: 'BANKRUPTCY_PROCEEDINGS_OPEN' as PhasesEnum,
        CREDITORSASSEMBLY: 'CREDITORS_ASSEMBLY' as PhasesEnum,
        FILINGINBANKRUPTCYFILE: 'FILING_IN_BANKRUPTCY_FILE' as PhasesEnum,
        BANKRUPTCYPROCEEDINGSOPENCLOSE: 'BANKRUPTCY_PROCEEDINGS_OPEN_CLOSE' as PhasesEnum,
        BANKRUPTCYPROCEEDINGSOPENCREDITORSASSEMBLY: 'BANKRUPTCY_PROCEEDINGS_OPEN_CREDITORS_ASSEMBLY' as PhasesEnum,
        BANKRUPTCYPROCEEDINGSCLOSE: 'BANKRUPTCY_PROCEEDINGS_CLOSE' as PhasesEnum,
        SUSPENDPREBANKRUPTCY: 'SUSPEND_PRE_BANKRUPTCY' as PhasesEnum,
        BANKRUPTCYTRUSTEECHANGE: 'BANKRUPTCY_TRUSTEE_CHANGE' as PhasesEnum,
        PROPERTYSALE: 'PROPERTY_SALE' as PhasesEnum,
        PROPERTYASSESSMENT: 'PROPERTY_ASSESSMENT' as PhasesEnum,
        PROCUREMENTSERVICESGOODS: 'PROCUREMENT_SERVICES_GOODS' as PhasesEnum,
        OTHER: 'OTHER' as PhasesEnum
    };
}